module.exports = __webpack_public_path__ + "img/gc_country_flag_fr.07193435.svg";